import { Injectable } from "@angular/core";
import { ValueAdapter } from "./value.adapter";

@Injectable()
/**
 * Different NitroDB data models might have different column names.
 * This class allows to connect widget JSON config with specific piece of logic in javascript.
 *
 * Widget config will refer to specific adapter via value_adapter parameter on input definition.
 * See this example:
 * {
    "id":"filter",
    "value": "inputs.fuzzy_filter.expression",
    "value_adapter": {"name": "build_filter_flowsec", "config": {"direction":"incoming"}}
   },
   {
    "id":"groupby",
    "value": "inputs.fuzzy_filter.expression",
    "value_adapter": {"name": "build_groupby_flowsec", "config": {"direction":"incoming"}}
   }
  And then, query template looks like this:
   ...
   "groupby": "${groupBy('app')}",
   "postFilter": "${filter}",
   ...
  The same input parameter (expression from fuzzy search input) is transformed 2 times:
  - as SQL where condition (site2 = 'Boston' AND ....) to be injected into query 'filter'.
  - as comma separated list of field names, to be added to groupby. See the example above, that explains how to populate
    groupby field dynamically. First, we call the function 'groupBy' and pass over the list of fields to be present in groupby
    (for example, you want to see data grouped by app name). The function 'groupBy' internally seeks parameter named 'groupby'
    and concatenates value of that parameter with static list, passed directly to  groupBy function.
    Yes, I know this is ugly and very weird. However this is the only way now to make query accepted by backend.

 */
export abstract class ValueAdapterProvider {
  // sample config: {"name": "build_groupby_flowsec_incoming", "config": {"direction":"incoming"}}
  abstract getPostprocessor(config):ValueAdapter;
}
